import type * as PhosphorIcons from "@phosphor-icons/react";
import { commonPhosphorIcons } from "./commonPhosphorIcons";

let complete: typeof PhosphorIcons | undefined;
let loading: Promise<typeof PhosphorIcons> | undefined;
export function loadPhosphorIcons(): Promise<typeof PhosphorIcons> {
  loading ??= import("@phosphor-icons/react")
    .then((icons) => {
      complete = icons;
      return icons;
    })
    .catch((error: unknown) => {
      loading = undefined;
      throw error;
    });
  return loading;
}
export function getPhosphorIcon(name: string): typeof PhosphorIcons.House | undefined {
  return (complete ?? commonPhosphorIcons)[name as keyof typeof commonPhosphorIcons];
}
